import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../types';
import {PageTitle} from "../../Components/Landmarks";
import {LayoutFullBleed} from "../../Components/Layout";
import {LibraryCatalogItem} from "./LibraryCatalogItem";
import {libraryCatalogApi} from "./libraryCatalogApi";
import {catalogItemModel} from "./libraryFactory";
import {locations} from "../../Utilities/Location";
import {isArrayNullOrEmpty} from "../../Utilities/Types/arrayUtilities";

export const LibraryCatalogWhatsNewContainer = ({
                                                    handleApiCall,
                                                    redirect,
                                                    systemType,
                                                    systemTypeText,
                                                }: ContextProps) => {
    const [resources, setResources] = useState<Record<string, any>[]>([]);

    const handleEdit = (id: string) => {
        const path = locations.LIBRARY_ITEM.getLink(id).to;
        redirect(path);
    }

    useEffect(() => {
        const getResources = () => {
            handleApiCall(() => libraryCatalogApi.getWhatsNew(systemType), (results: Record<string, any>[]) => setResources(results));
        }

        getResources();
    }, []);

    return <>
        <PageTitle h1={systemTypeText}/>

        <LayoutFullBleed className={`catalog`}>
            <header>
                <h2>What&apos;s New</h2>
            </header>

            {
                resources.map((resource: Record<string, any>) => {
                    const item = catalogItemModel(resource);
                    const handleClickEdit = () => handleEdit(item.catalogId);
                    return <LibraryCatalogItem
                        key={item.catalogId}
                        handleClickEdit={handleClickEdit}
                        {...item}
                    />;
                })
            }
            {
                isArrayNullOrEmpty(resources) &&
                <p className={`text-center`}>No results.</p>
            }

        </LayoutFullBleed>
    </>;
};
